import '../../components/Alignment.css';
import '../../DataTable.css';
import '../../../../core/components/app-root/AppRoot.css';
import '../../components/DataTableVirtualizationContainer.css';
import '../RowOrder/RowOrder.css';
import '../RowDetails/RowDetails.css';
import '../RowInteractivity/RowInteractivity.css';
import '../../components/DataTableRow.css';
import '../Thresholds/Thresholds.css';
import '../../components/DataTableCell.css';
import '../ColumnOrder/ColumnOrder.css';
import '../../components/DataTableHeaderCell.css';
import '../../components/DataTableDefaultCell.css';
import './UserActions.css';
export var actionButton = '_duopj90-3-5-0';
export var floatingMenuButton = '_duopj91-3-5-0';